/* eslint-disable react/jsx-props-no-spreading */
import React, { Component } from 'react';
import { ConstantBasedPicker } from '@openimis/fe-core';

import { INDICATOR_TYPES, MODULE_NAME } from '../constants';

class IndicatorTypePicker extends Component {
  render() {
    const { intl, readOnly = false } = this.props;

    return (
      <ConstantBasedPicker
        constants={INDICATOR_TYPES}
        readOnly={readOnly}
        {...this.props}
      />
    );
  }
}

export default IndicatorTypePicker;
